import { Constructable, RAZORPAY_SCRIPT, RazorpayOptions, RazorpaySuccessHandlerArgs } from '@systemeio/digital-store-shared';
import { loadScriptAsync } from '@systemeio/util';
import { RazorpayUserPlanUpgradeResponse } from 'modules/profile/user-plan/types/user-plan-interface';
import { useCallback, useState } from 'react';
interface RazorpayInstance {
  open(): void;
  on(event: 'payment.failed', callback: (data: {
    error: {
      description: string;
    };
  }) => void): void;
}

// Not augmenting the global `Window` type here: digital-store-shared's own
// useRazorpay hook already declares a conflicting global `Window.Razorpay` shape.
const getRazorpayConstructor = () => (window as unknown as {
  Razorpay: Constructable<RazorpayInstance>;
}).Razorpay;
export interface UseRazorpayUserPlanCheckoutParams {
  onAuthorized: (args: RazorpaySuccessHandlerArgs) => void;
  onDismiss: () => void;
  onFailed: (message: string) => void;
}
export const useRazorpayUserPlanCheckout = ({
  onAuthorized,
  onDismiss,
  onFailed
}: UseRazorpayUserPlanCheckoutParams) => {
  const [isScriptLoading, setIsScriptLoading] = useState(false);
  const openCheckout = useCallback(async (razorpayResponse: RazorpayUserPlanUpgradeResponse) => {
    if (!('Razorpay' in window)) {
      setIsScriptLoading(true);
      try {
        await loadScriptAsync(RAZORPAY_SCRIPT);
      } finally {
        setIsScriptLoading(false);
      }
    }
    const options: RazorpayOptions = {
      key: razorpayResponse.keyId,
      subscription_id: razorpayResponse.rpSubscriptionId,
      name: razorpayResponse.vendorName,
      prefill: {
        name: razorpayResponse.prefill.name,
        email: razorpayResponse.prefill.email,
        contact: razorpayResponse.prefill.phone
      },
      handler: onAuthorized,
      modal: {
        ondismiss: onDismiss
      }
    };
    const RazorpayConstructor = getRazorpayConstructor();
    const instance = new RazorpayConstructor(options);
    instance.on('payment.failed', data => onFailed(data.error.description));
    instance.open();
  }, [onAuthorized, onDismiss, onFailed]);
  return {
    openCheckout,
    isScriptLoading
  };
};